import React from 'react';

class ButtonIcon extends React.Component {
  render() {
    const icon = this.props.icon;

    if (!icon) {
      return false;
    }

    return React.createElement("i", {
      className: "admin-button__icon  material-icons"
    }, icon);
  }

}

export default ButtonIcon;